<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>优惠券管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="100px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="赛事活动" prop="activityType">
              <el-select
                style="width: 100%"
                v-model="queryForm.activityType"
                disabled
              >
                <el-option
                  v-for="item in activityTypeList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择赛季"
                style="width: 100%"
                v-model="queryForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" prop="status">
              <el-select
                placeholder="请选择"
                v-model="queryForm.status"
                style="width: 100%"
              >
                <el-option label="上架" value="1"></el-option>
                <el-option label="下架" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优惠券" prop="couponName">
              <el-input
                v-model="queryForm.couponName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="起止时间" prop="dateTimeRange">
              <el-date-picker
                v-model="dateTimeRange"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="dateChangeClicked"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button type="primary" style="width: 100%" @click="search"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">优惠券信息</span>
        </el-col>
        <el-col :span="15" style="text-align: right">
          <el-button type="primary" @click="newFn">创建优惠券</el-button>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="优惠券名称" prop="couponName"></el-table-column>
        <el-table-column label="优惠金额" prop="discountAmount">
          <template slot-scope="scope">
            <div class="price">¥{{ scope.row.discountAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column label="优惠券类型" prop="couponType">
          <template slot-scope="scope">
            <el-button round :type="scope.row.couponType === 1 ? 'primary' : 'success'" size="mini">{{ scope.row.couponType === 1 ? '满减' : '无门槛' }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="最低购买金额" prop="minimumPurchase"></el-table-column>
        <el-table-column label="有效期" prop="expirationDate"></el-table-column>
        <!-- <el-table-column label="关联产品" prop="productName"></el-table-column> -->
        <!-- <el-table-column label="创建人" prop="creator"></el-table-column> -->
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="状态" prop="status" width="120px">
          <template slot-scope="scope">
            <!-- <el-tag :type="scope.row.status ? 'success' : 'danger'" size="mini">
              {{ scope.row.status ? '上架' : '下架' }}
            </el-tag> -->
            <el-switch
              v-model="scope.row.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="changeStatus(scope.row)"
              >
            </el-switch>
            {{ scope.row.status ? '已上架' : '已下架' }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleToDetail(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 编辑信息的dialog -->
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="700px"
      @close="closeFn"
    >
      <el-form
        :model="editForm"
        label-width="110px"
        ref="editInfoFormRef"
        :rules="editInfoRules"
        style="width: 100%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="赛事活动" prop="activityType">
              <el-select
                style="width: 100%"
                v-model="editForm.activityType"
                disabled
              >
                <el-option
                  v-for="item in activityTypeList"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择赛季"
                style="width: 100%"
                v-model="editForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="关联产品" prop="productIds">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="editForm.productIds"
                @change="productChange"
              >
                <el-option
                  v-for="item in productList"
                  :key="item.id"
                  :label="item.productName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="editForm.productIds">
            <el-form-item label="产品详情">
                <el-checkbox :label="product.tproductName" v-model="product.checked" v-for="product of productDetails" :key="product.id"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="优惠券名称" prop="couponName">
              <el-input
                v-model="editForm.couponName"
                placeholder="请填写优惠券名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="使用规则" prop="description">
              <el-input
                v-model="editForm.description"
                type="textarea"
                :rows="6"
                placeholder="请填写使用规则，回车换行"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效截止时间" prop="expirationDate">
              <el-date-picker
                v-model="expirationDate"
                @change="dateChange"
                type="datetime"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠金额" prop="discountAmount">
              ¥ <el-input style="width: 206px;"
                v-model="editForm.discountAmount"
                placeholder="请填写优惠金额"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠券类型" prop="couponType">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="editForm.couponType"
              >
                <el-option label="满减" :value="1"></el-option>
                <el-option label="无门槛" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="editForm.couponType === 1">
            <el-form-item label="最低购买金额" prop="minimumPurchase">
              ¥ <el-input style="width: 206px;"
                v-model="editForm.minimumPurchase"
                placeholder="请填写最低购买金额"
                type="number"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优惠券状态" prop="status">
              <el-switch
                v-model="status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="changeStatus1"
                >
              </el-switch>
              {{ editForm.status === 1 ? '上架' : '下架' }}
              <!-- <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="editForm.status"
              >
                <el-option label="上架" :value="1"></el-option>
                <el-option label="下架" :value="0"></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'semi_final_form_code',
  data () {
    return {
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      activityTypeList: this.$userInfo.getDataList(this, 'activity_type').then(value => { this.activityTypeList = value }),
      dict_Group: this.$userInfo.dict_group(),
      queryForm: {
        activityType: String(this.$chnEngStatusCode.activityType),
        season: this.$chnEngStatusCode.defaultSeason,
        couponName: '',
        beginTime: '',
        endTime: '',
        status: ''
      },
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dataList: [],
      title: '',
      visible: false,
      editForm: {
        activityType: String(this.$chnEngStatusCode.activityType),
        season: this.$chnEngStatusCode.defaultSeason,
        couponName: '',
        couponType: '',
        discountAmount: '',
        expirationDate: '',
        minimumPurchase: '',
        productIds: '',
        status: 1,
        description: ''
      },
      status: true,
      editInfoRules: {
        couponName: [{ required: true, message: '请输入', trigger: 'blur' }],
        couponType: [{ required: true, message: '请选择', trigger: 'change' }],
        discountAmount: [{ required: true, message: '请输入', trigger: 'blur' }],
        minimumPurchase: [{ required: true, message: '请输入', trigger: 'blur' }],
        description: [{ required: true, message: '请输入', trigger: 'blur' }],
        expirationDate: [{ required: true, message: '请选择', trigger: 'change' }],
        season: [{ required: true, message: '请选择', trigger: 'change' }],
        productIds: [{ required: true, message: '请选择', trigger: 'change' }]

      },
      editType: '',
      dateTimeRange: [],
      productList: [],
      expirationDate: null,
      productDetails: [] // 产品详情
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getDataList () {
      const params = { ...this.queryForm, ...{ pageNum: this.pageIndex, pageSize: this.pageSize } }
      this.$http.get('coupon/queryTbCouponPage', { params }).then(res => {
        if (res.code === 200) {
          this.dataList = res.data.list
          this.total = res.data.total
        }
      })
    },
    search () {
      this.pageIndex = 1
      this.getDataList()
    },
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.queryForm.beginTime = ''
      this.queryForm.endTime = ''
      this.dateTimeRange = []
      this.search()
    },
    handleSizeChange (e) {
      this.pageSize = e
      this.getDataList()
    },
    handleCurrentChange (e) {
      this.pageIndex = e
      this.getDataList()
    },
    newFn () {
      this.getProductList()
      this.visible = true
      this.title = '创建优惠券'
      this.editType = 0
    },
    closeFn () {
      this.visible = false
      this.$refs.editInfoFormRef.resetFields()
      this.status = true
      this.expirationDate = null
    },
    saveFn () {
      this.$refs.editInfoFormRef.validate(valid => {
        if (!valid) return
        // 产品详情处理
        this.editForm.showProducts = this.productDetails.filter(item => item.checked).map(item => item.id).join(',')
        this.$http.post('coupon/saveTbCoupon', this.editForm).then(res => {
          if (res.code === 200) {
            // this.$message.success('创建成功')
            this.closeFn()
            this.$confirm('优惠券创建成功，是否发放?', '提示', {
              confirmButtonText: '现在就去',
              cancelButtonText: '稍后',
              type: 'warning'
            }).then(() => {
              this.handleToDetail({ id: res.data })
            }).catch(() => {
              this.search()
            })
          }
        })
      })
    },
    dateChangeClicked (val) {
      if (val.length === 2) {
        this.queryForm.beginTime = val[0]
        this.queryForm.endTime = val[1]
      }
    },
    dateChange () {
      this.editForm.expirationDate = this.$moment(this.expirationDate).format('YYYY-MM-DD HH:mm:ss')
    },
    getProductList () {
      this.$http.get('lexicon/getTbProductList', { params: { pageNum: 1, pageSize: 100, activityType: this.queryForm.activityType } }).then(res => {
        this.productList = res.data
      })
    },
    changeStatus (item) {
      console.log(item)
      this.$http.post('coupon/updateTbCouponInfo', { id: item.id, status: item.status }).then(res => {
        if (res.code === 200) {
          this.$message.success(item.status ? '优惠券已上架' : '优惠券已下架')
          this.getDataList()
        }
      })
    },
    changeStatus1 () {
      this.editForm.status = this.status ? 1 : 0
    },
    handleToDetail (item) {
      this.$router.push(`/raceManagement/individual_management/couponDetail?id=${item.id}`)
    },
    productChange () {
      if (this.editForm.productIds) {
        this.$http.get('lexicon/getTbProductDetailList', { params: { productId: this.editForm.productIds } }).then(res => {
          if (res.code === 200) {
            res.data.forEach(item => {
              item.checked = true
            })
            this.productDetails = res.data
          }
        })
      }
    }

  }
}
</script>
<style lang="less" scoped>
.price{
  color: #409EFF;
  font-size: 18px;
  font-weight: 600;
}
/deep/ .el-checkbox{
  display: block;
}
</style>
